"use client";

import React from "react";
import { Menu, ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuTrigger, NavigationMenuContent, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { cn } from "@/lib/utils";
function DesktopNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-9 w-24 animate-pulse rounded-lg bg-muted/50" />)}
      </div>;
  }
  const mappedItems = menuItems.map(item => {
    if (item.href === "/AccommodationsPage") {
      return {
        ...item,
        label: "Szállások"
      };
    }
    if (item.href === "/FlightsPage") {
      return {
        ...item,
        label: "Repülőjegyek",
        href: "https://aviasales.tpx.gr/mQ5kgFOd"
      };
    }
    if (item.href === "/AutoBerlesPage") {
      return {
        ...item,
        label: "Autó Bérlés"
      };
    }
    if (item.label === "Taxi Foglalas Submenu" || item.id === "216") {
      return {
        ...item,
        label: "Taxi & Transzfer",
        children: [{
          id: "child-1",
          label: "Taxi",
          href: "https://kiwitaxi.tpx.gr/VJKGLDBI"
        }, {
          id: "child-2",
          label: "Reptéri Transzfer",
          href: "https://kiwitaxi.tpx.gr/VJKGLDBI"
        }]
      };
    }
    if (item.href === "/TaxiBookingPage") {
      return {
        ...item,
        label: "Taxi",
        href: "https://kiwitaxi.tpx.gr/VJKGLDBI"
      };
    }
    if (item.label === "Kerékpár Foglalás") {
      return {
        ...item,
        href: "https://bikesbooking.tpx.gr/zSuRJg9W"
      };
    }
    if (item.label === "Esemeny belepo") {
      return {
        ...item,
        label: "Esemény belépő"
      };
    }
    return item;
  });
  const otherItems = mappedItems.filter(item => item.label !== "Kapcsolat");
  const contactItem = mappedItems.find(item => item.label === "Kapcsolat");
  const sortedItems = contactItem ? [...otherItems, contactItem] : mappedItems;
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-2">
        {sortedItems.map((item, i) => {
        const isExternalLink = item.href?.startsWith("https://kiwitaxi.tpx.gr") || item.href?.startsWith("https://bikesbooking.tpx.gr") || item.href?.startsWith("https://aviasales.tpx.gr");
        if (item.children && item.children.length > 0) {
          return <NavigationMenuItem key={item.id} data-index={i}>
                <NavigationMenuTrigger className={cn(navigationMenuTriggerStyle(), "bg-transparent text-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground data-[state=open]:bg-primary/10 transition-all rounded-lg")}>
                  {item.label}
                </NavigationMenuTrigger>
                <NavigationMenuContent className="min-w-[200px] bg-background border border-border shadow-lg rounded-lg p-2">
                  <ul className="flex flex-col gap-1">
                    {item.children.map((child, childIdx) => <li key={child.id} data-index={childIdx}>
                        <NavigationMenuLink asChild>
                          <Link to={child.href || "#"} className="block px-4 py-2 text-sm font-medium text-foreground hover:bg-primary hover:text-primary-foreground rounded-lg transition-colors" target="_blank" rel="noopener noreferrer">
                            {child.label}
                          </Link>
                        </NavigationMenuLink>
                      </li>)}
                  </ul>
                </NavigationMenuContent>
              </NavigationMenuItem>;
        }
        return <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className={cn(navigationMenuTriggerStyle(), "bg-transparent text-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground data-[active=true]:text-primary data-[state=open]:bg-transparent transition-all rounded-lg")} {...isExternalLink ? {
              target: "_blank",
              rel: "noopener noreferrer"
            } : {}}>
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>;
      })}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="mt-8 flex flex-col gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-10 w-full animate-pulse rounded-lg bg-muted/50" />)}
      </div>;
  }
  const mappedItems = menuItems.map(item => {
    if (item.href === "/AccommodationsPage") {
      return {
        ...item,
        label: "Szállások"
      };
    }
    if (item.href === "/FlightsPage") {
      return {
        ...item,
        label: "Repülőjegyek",
        href: "https://aviasales.tpx.gr/mQ5kgFOd"
      };
    }
    if (item.href === "/AutoBerlesPage") {
      return {
        ...item,
        label: "Autó Bérlés"
      };
    }
    if (item.label === "Taxi Foglalas Submenu" || item.id === "216") {
      return {
        ...item,
        label: "Taxi & Transzfer",
        children: [{
          id: "child-1",
          label: "Taxi",
          href: "https://kiwitaxi.tpx.gr/VJKGLDBI"
        }, {
          id: "child-2",
          label: "Reptéri Transzfer",
          href: "https://kiwitaxi.tpx.gr/VJKGLDBI"
        }]
      };
    }
    if (item.href === "/TaxiBookingPage") {
      return {
        ...item,
        label: "Taxi",
        href: "https://kiwitaxi.tpx.gr/VJKGLDBI"
      };
    }
    if (item.label === "Kerékpár Foglalás") {
      return {
        ...item,
        href: "https://bikesbooking.tpx.gr/zSuRJg9W"
      };
    }
    if (item.label === "Esemeny belepo") {
      return {
        ...item,
        label: "Esemény belépő"
      };
    }
    return item;
  });
  const otherItems = mappedItems.filter(item => item.label !== "Kapcsolat");
  const contactItem = mappedItems.find(item => item.label === "Kapcsolat");
  const sortedItems = contactItem ? [...otherItems, contactItem] : mappedItems;
  return <div className="mt-8 flex flex-col gap-2">
      {sortedItems.map((item, i) => {
      const isExternalLink = item.href?.startsWith("https://kiwitaxi.tpx.gr") || item.href?.startsWith("https://bikesbooking.tpx.gr") || item.href?.startsWith("https://aviasales.tpx.gr");
      if (item.children && item.children.length > 0) {
        return <div key={item.id} data-index={i} className="flex flex-col gap-1">
              <div className="px-4 py-2 text-lg font-semibold text-foreground/70 uppercase tracking-wider text-xs">
                {item.label}
              </div>
              <div className="flex flex-col gap-1 pl-4">
                {item.children.map((child, childIdx) => <Link key={child.id} data-index={childIdx} to={child.href || "#"} className="text-lg font-medium text-foreground transition-all hover:bg-primary hover:text-primary-foreground px-4 py-2 rounded-lg" target="_blank" rel="noopener noreferrer">
                    {child.label}
                  </Link>)}
              </div>
            </div>;
      }
      return <Link key={item.id} data-index={i} to={item.href || "#"} className="text-lg font-medium text-foreground transition-all hover:bg-primary hover:text-primary-foreground px-4 py-2 rounded-lg" {...isExternalLink ? {
        target: "_blank",
        rel: "noopener noreferrer"
      } : {}}>
            {item.label}
          </Link>;
    })}
    </div>;
}
export default function TravelHeader() {
  return <section id="header" className="sticky top-0 z-50 w-full border-b border-border bg-background/90 backdrop-blur-md supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto grid h-20 grid-cols-12 items-center gap-4 px-4 md:px-6 lg:px-8">
        
        <div className="col-span-6 flex items-center md:col-span-3 lg:col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <WvcLogo className="h-7 w-auto" />
          </Link>
        </div>

        <div className="hidden md:block md:col-span-6 lg:col-span-7">
          <MenuProvider menu_id="16">
            <DesktopNav />
          </MenuProvider>
        </div>

        
        <div className="col-span-6 flex items-center justify-end gap-2 md:col-span-3 lg:col-span-3 sm:gap-4">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:bg-transparent hover:text-primary">
                <Menu className="size-6" />
                <span className="sr-only">Menü megnyitása</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] border-l border-border bg-background/95 backdrop-blur-xl sm:w-[400px]">
              <SheetTitle className="text-left font-default text-xl text-foreground">
                Menü
              </SheetTitle>
              <MenuProvider menu_id="16">
                <MobileNav />
              </MenuProvider>
              <div className="mt-auto pt-8">
                <Button className="w-full rounded-lg bg-primary py-6 font-default text-lg font-medium text-primary-foreground shadow-md hover:bg-primary/90">
                  Autó Bérlés
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </section>;
}